import dhtmlXTreeObject from '../../../dx/dxSource/components/dhtmlXTreeObject';
import goingDialog from "../../../jsCom/comCtl/goingDialog";
import {AssertUtils, GoingUtils} from "goingutils";
import InitGridObj from "../../../dx/dxInitUtils/initGridObj";
import WinUtils from "../../../winUtils";

class WinBase {
    constructor(options) {
        this.options = options;
    }

    showDialogWin(htmlContent,closeFun) {
        let url=GoingUtils.getUUid(20);
        let {
            width = 820,
            height = 660,
            anim = 2,
            title = "窗口标题",
            bottomBtn = false
        } = this.options;
        let curWinObj = goingDialog.open({
            type: 1,
            closeWin:closeFun,
            title: title,
            closeBtn: 1, //不显示关闭按钮
            bottomBtn: bottomBtn,
            shade: [0.3],
            area: [`${width}px`, `${height}px`],
            anim: anim,
            content: htmlContent
        });
        WinUtils.winIdMap[url]=curWinObj;
        WinUtils.curWinIds.push(curWinObj);

        this.winUuid=url;
    }

    getLeftBtnHtmls(leftBtns = [],divId) {
        let btns = [];
        leftBtns.forEach(function (item) {
            btns.push(` <div  id="${divId}_${item.id}" class="pull-left go-btn-simple no-padding primary" style="top:1px;display:block;border-radius: 20px;">${item.name}</div>`);
        })
        return btns.join("\n");
    }

    getBottonBtnHtmls(leftBtns,divId) {
        return `<div class="dialog-bt-bar " style="position: absolute;padding-top: 3px;box-sizing: border-box;bottom:0">
                  <div class="go-tool-bar clearfix" style="min-height: 37px;padding-top: 5px;box-sizing: border-box;">
                       ${this.getLeftBtnHtmls(leftBtns,divId)} 
                      <div btnid="go_form_confirmBtn" class="go_form_confirmBtn pull-right go-btn-simple no-padding primary" style="top:1px;display:block;border-radius: 20px;">${'确定'}</div>
                      <div btnid="go_form_continueBtn"  class="go_form_continueBtn pull-right go-btn-simple no-padding primary" style="top:1px;display:block;">${'继续添加'}</div>
                      <div btnid="go_form_cancelBtn" class="go_form_cancelBtn pull-right go-btn-simple no-padding gray" style="top:1px;border-radius: 20px;">${'取消'}</div>
                  </div>
            </div>`;
    }

    //添加底部工具栏
    addBottomBar(divId, leftBtns = []) {
        let btnHtmls = this.getBottonBtnHtmls(leftBtns,divId);
        $(btnHtmls).appendTo($("#" + divId).parent());
    }

    //初始化底部事件divId, goAclWin, vueObj
    initBottomEvent({divId, goAclWin, vueObj, treeObj,leftBtns=[],closeWin}) {

        let dialogWin = this;
        //注册 左侧按钮的点击事件
        leftBtns.forEach(function (item) {
            $("#" + divId + "_" + item.id).click(function () {
                item["fun"](goAclWin, vueObj, treeObj);
            });
        })

        //存在继续添加按钮事件 才显示该按钮不然则隐藏掉
        if (AssertUtils.isFunction(dialogWin.options.confirmBtn)) {
            //点击确定按钮
            $("#" + divId)
                .closest(".layui-layer-content")
                .find(".go_form_confirmBtn")
                .click(function () {
                    dialogWin.options.confirmBtn(goAclWin, vueObj, treeObj);
                });
        }else{
            $("#" + divId)
                .closest(".layui-layer-content")
                .find(".go_form_confirmBtn")
                .hide();
        }

        //存在继续添加按钮事件 才显示该按钮不然则隐藏掉
        if (AssertUtils.isFunction(dialogWin.options.continueBtn)) {
            //点击继续添加按钮
            $("#" + divId)
                .closest(".layui-layer-content")
                .find(".go_form_continueBtn")
                .click(function () {
                    dialogWin.options.continueBtn(goAclWin, vueObj, treeObj);
                });
        } else {
            $("#" + divId)
                .closest(".layui-layer-content")
                .find(".go_form_continueBtn")
                .hide();
        }

        //点击取消按钮
        $("#" + divId)
            .closest(".layui-layer-content")
            .find(".go_form_cancelBtn")
            .click(function () {
                closeWin&&closeWin();
                WinUtils.closeParentCurWin(true,dialogWin.winUuid);
            });
    }

    //激活表格对象
    attachGridObj(divId, vueObj) {
        let {config} = this.options;
        //初始化表格
        config["hasPagin"] = true;
        //激活表格对象
        let gridObj = InitGridObj(divId, config, vueObj);
        return gridObj;
    }

    //激活树
    attachTreeObj(divId, clickFun, gridObj) {
        let {treeUrl, initFun} = this.options.config;
        //初始化树组件
        let treeObj = new dhtmlXTreeObject(
            divId,
            "100%",
            $(`#${divId}`).height() + "px",
            0
        );

        //根据树url进行查询
        if (AssertUtils.isNotEmpty(treeUrl)) {
            console.log(this.options,"=====this.options");
            if (this.options.config.backFun) {
                treeObj.flushTreeByUrl({url: treeUrl, backFun: this.options.config.backFun});
            } else {
                if (this.options.backFun) {
                    treeObj.flushTreeByUrl({url: treeUrl, backFun: this.options.backFun});
                } else {
                    treeObj.flushTreeByUrl({url: treeUrl});
                }
            }
        }
        //如果存在初始化函数
        if (AssertUtils.isNotNull(initFun) && AssertUtils.isFunction(initFun)) {
            initFun(treeObj);
        }

        //如果传入了drag  如果drag为true 则表示可以拖动
        if (this.options.config.drag) {
            treeObj.setDragBehavior("sibling");
            treeObj.enableDragAndDrop(true, false);
        }
        //如果传入了checkBox
        if (this.options.config.checkBox) {
            treeObj.enableCheckBoxes(1);
            treeObj.enableThreeStateCheckboxes(true);
        }
        //如果传入了radioBox
        if (this.options.config.radioBox) {
            treeObj.enableRadioButtons(true);
        }
        //如果存在点击事件 才执行
        if (clickFun != null && AssertUtils.isFunction(clickFun)) {
            //注册树事件
            treeObj.attachEvent("onClick", function (id) {
                clickFun({nodeId: id, gridObj});
                return true;
            });
        }
        return treeObj;
    }

    //初始化容器的高度
    initWinContainer(divId) {
        let height = 46;
        let oldHeight = $("#" + divId).height();
        $("#" + divId).height(parseFloat(oldHeight) - height);
        $("#" + divId)
            .closest(".layui-layer-content")
            .css("overflow", "hidden");
    }
}

export default WinBase;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/go-dialog/components/winBase.js